export default __webpack_public_path__ + "static/dominican-republic-04c0203803aaa8ab251df773b15556ce.svg";